import { addClass } from '@touchvue/utils'
import { nextTick } from 'vue'
import type { Directive } from 'vue'

const setAlign = (el: HTMLElement, binding: any) => {
	if (binding.value) {
		nextTick(() => {
			if (['left', 'right', 'center', 'inherit'].indexOf(binding.value) > -1) {
				addClass(el, 'to-align-' + binding.value)
			}
		})
	}
}

const vAlignDirective: Directive = {
	mounted(el: HTMLElement, binding) {
		binding.value && setAlign(el, binding)
	},
	updated(el: HTMLElement, binding) {
		setAlign(el, binding)
	},
	unmounted(_el: HTMLElement, _binding) {
		// Vue3中不需要手动销毁实例
	},
}

export default vAlignDirective
